import React, { useState, useRef, useEffect } from 'react';

import { GridColumnMenuItemGroup, GridColumnMenuItemContent } from "@progress/kendo-react-grid";
import { Checkbox } from "@progress/kendo-react-inputs";

const ColumnMenu = (props) => {
	
	const { columns, hiddenColumns, onHiddenColumnsChanged, onRestoreClicked } = props;
	
	const [columnState, setColumnState] = useState(columns.map((column) => { return {...column, show: !hiddenColumns.includes(column.field)}; }));
	
	const focusRef = useRef();
	
	useEffect(() => {
		focusRef.current.focus();
	}, []);
	
	const onToggleColumn = (event, field) => {
		setColumnState(columnState.map((column) => {
			if (column.field == field) return {...column, show: event.value};
			else return column;		
		}));		
	};
	
	const onSubmit = (event) => {
		event.preventDefault();
		onHiddenColumnsChanged(columnState.filter((column) => !column.show).map((column) => column.field));
		if (props.onCloseMenu) props.onCloseMenu();
	};
	
	const onReset = (event) => {
		event.preventDefault();
		setColumnState(columns.map((column) => ({...column, show: true})));
		onHiddenColumnsChanged([]);
		if (props.onCloseMenu) props.onCloseMenu();
	};
	
	const getColumns = () => {
		return columnState.map((column) => (
			<div key={column.field} className={"k-column-list-item"}>
				<span
					className="constituo-column-menu-checkbox-row"
					style={{
					    display: "inline-flex",
					    alignItems: "center",
					}}				
				>
					<Checkbox
						tabIndex={0}
						id={`column-visiblity-show-${column.field}`}
						className="constituo-checkbox-field"
						value={column.show}
						onChange={(e) => onToggleColumn(e, column.field)} 
					/>				
					<label
			          	htmlFor={`column-visiblity-show-${column.field}`}
						className="k-checkbox-label"
			            style={{
							paddingLeft: "3px",
			                userSelect: "none",
						}}
					>
			         	{column.title}
					</label>
				</span>
			</div>
		));
	};

	return (
    	<div tabIndex={0} role="menu" aria-label="Grid Column Menu" ref={focusRef}>
      		<GridColumnMenuItemGroup>
      			<GridColumnMenuItemContent show={true}>
					<div tabIndex={0} role="button" aria-label="Restore Layout" className="constituo-column-menu" onClick={onRestoreClicked}>
        				<span className="constituo-column-menu-icon fa fa-fw fa-small fa-window-maximize" />
        				<span className="constituo-column-menu-label">{"Restore Layout"}</span>
        			</div>
        		</GridColumnMenuItemContent>
	      	</GridColumnMenuItemGroup>
     		<GridColumnMenuItemGroup>
        		<GridColumnMenuItemContent show={true}>
        			<div className="constituo-column-menu">
        				<span className="constituo-column-menu-icon fa fa-fw fa-small fa-rotate-90 fa-menu" />
        				<span>{"Columns"}</span>
        			</div>
        		</GridColumnMenuItemContent>
        		<GridColumnMenuItemContent show={true}>
          			<div className={"k-column-list-wrapper"}>
            			<form onSubmit={onSubmit} onReset={onReset}>          			
							<div className={"k-column-list"}>
              					{getColumns()}
							</div>
							<div className={"k-actions k-hstack k-justify-content-stretch"}>
                				<button
                					tabIndex={0} 
                  					type={"reset"}
                  					className={"k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"}
                				>
                  					Reset
                				</button>
                				<button
                					tabIndex={0}
                  					className={"k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"}
                				>
                  					Save
                				</button>
              				</div>							
						</form>
          			</div>
        		</GridColumnMenuItemContent>
      		</GridColumnMenuItemGroup>
		</div>
  	);
};

export default ColumnMenu;

